import { ChangeEvent, memo, ReactNode, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, MenuItem, TextField, Typography } from '@mui/material';

import { TwoFactorAuthenticationType } from '@/legacy/features/user/twoFactorAuthentication/twoFactorAuthentication';

interface Props {
  isLoading?: boolean;
  onVerificationMethodChange: {
    (e: ChangeEvent<HTMLInputElement>): void;
  };
  verificationMethod: TwoFactorAuthenticationType;
  isMaxNumberOfAuthMethodsReachedForCurrentType: boolean;
}

const VerificationProvider = (props: Props): React.JSX.Element => {
  const {
    isLoading,
    onVerificationMethodChange,
    verificationMethod,
    isMaxNumberOfAuthMethodsReachedForCurrentType,
  } = props;

  const SecondaryText = useCallback(
    (chunk: ReactNode) => (
      <Typography component="span" color="textSecondary" variant="body2" ml={1}>
        {chunk}
      </Typography>
    ),
    []
  );

  return (
    <>
      <Box mt={2} mb={3}>
        <Typography gutterBottom>
          <FormattedMessage defaultMessage="To setup your two-step authentication please select your authentication provider" />
        </Typography>
      </Box>
      <Box my={3}>
        <TextField
          select
          fullWidth
          id="authentication-provider"
          defaultValue={verificationMethod}
          onChange={onVerificationMethodChange}
          label={<FormattedMessage defaultMessage="Authentication Provider" />}
          autoFocus
          disabled={isLoading}
          error={isMaxNumberOfAuthMethodsReachedForCurrentType}
          helperText={
            isMaxNumberOfAuthMethodsReachedForCurrentType ? (
              <FormattedMessage
                defaultMessage="You've reached the maximum number of {verificationMethod, select, Otp {authenticator apps} Sms {SMS phone numbers} other {verification methods}}."
                values={{ verificationMethod }}
              />
            ) : null
          }
        >
          <MenuItem value={TwoFactorAuthenticationType.Otp}>
            <FormattedMessage
              defaultMessage="Authenticator App <SecondaryText>(Recommended)</SecondaryText>"
              values={{ SecondaryText }}
            />
          </MenuItem>
          <MenuItem value={TwoFactorAuthenticationType.Sms}>
            <FormattedMessage defaultMessage="SMS Message" />
          </MenuItem>
        </TextField>
      </Box>
    </>
  );
};

export default memo(VerificationProvider);
